__turbopack_context__.v({
  "learn": "KS7p8G_learn",
  "learnWrapper": "KS7p8G_learnWrapper",
});
